import AppObj from 'model/appConfigObj';
import { TaskInitParams } from 'model/taskObj';
import React, { useContext, useEffect, useMemo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { desktopAppTaskContex } from 'screen/desktop';
import { fileBasename } from 'util/openableFile';
import './unsupportedFile.css';

export const unsupportedFileConfig = {
  appID: 'unsupportedFile',
  showName: 'Cannot Open',
  onList: false,
  icon: require('./images/wxllpaper.png'),
  maxHead: 8,
  req: {
    minSize: { width: 360, height: 220 },
    defSize: { width: 440, height: 280 },
  },
};

function parseInitParams(parms?: TaskInitParams[]) {
  let filePath = '';
  let fileName = '';
  if (parms) {
    for (const p of parms) {
      if (p.command === 'filePath' && p.value) {
        filePath = p.value;
      }
      if (p.command === 'fileName' && p.value) {
        fileName = p.value;
      }
    }
  }
  if (!fileName && filePath) {
    fileName = fileBasename(filePath);
  }
  return { filePath, fileName };
}

function UnsupportedFile(props: { taskInitParms?: TaskInitParams[]; taskID?: string }) {
  const [desktopControll] = useContext(desktopAppTaskContex);
  const init = useMemo(() => parseInitParams(props.taskInitParms), [props.taskInitParms]);

  useEffect(() => {
    if (!props.taskID || !init.fileName) {
      return;
    }
    desktopControll?.setTaskTitle?.(props.taskID, init.fileName);
  }, [props.taskID, init.fileName, desktopControll]);

  const download = () => {
    if (init.filePath) {
      desktopControll?.launchFileDownload?.(init.filePath, init.fileName);
    }
  };

  return (
    <div className="uf-root">
      <h2>Cannot open this file</h2>
      <p>
        Your browser does not support opening this file online.
      </p>
      {init.fileName ? <code title={init.filePath}>{init.fileName}</code> : null}
      <button type="button" className="uf-download" disabled={!init.filePath} onClick={download}>
        <FontAwesomeIcon icon={faDownload} />
        {' Download'}
      </button>
    </div>
  );
}

const App: AppObj = {
  config: unsupportedFileConfig,
  body: UnsupportedFile,
};

export default App;
